<template>
    <div class="overlay">
        <div class="overlay_inner">
            <div class="overlay_content">
                <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">{{ trans('common.loading') }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>
